import { globalCss } from "@grupoboticario/flora-react";

export const globalStyles = globalCss({
    '*': {
      margin: 0,
      padding: 0,
      boxSizing: 'border-box'
    },
  
    'html, body': {
      overflowX: 'hidden'
    },
  
    body: {
      fontFamily: 'Trebuchet MS, Verdana, Arial, Helvetica, sans-serif',
      overflowX: 'hidden',
      position: 'relative',
      fontSize: 16,
      color: '#515151',
      backgroundColor: 'rgb(255, 255, 255)'
    },
    a: {
      textDecoration: "none"
    }
    
  })
  